import { getConfig } from '@/configs/config-accessor';
import { REQUEST_HEADER_AUTH_KEY } from '@/constants/api.constant';
import { handleGetCollection } from '@/constants/db-collection.constants';
import { IUploadedFile } from '@/utils/upload-file';
import axios from 'axios';
import ApiService from './ApiService';
import { handleSetApiAuthorizationHeader } from './BaseService';

// Get the API prefix from the config accessor
const getApiPrefix = () => getConfig().newApiPrefix;

export interface IUser {
  _id: string;
  auth: string;
  role: { value: IUserRole['_id']; label: string };
  name: string;
  userName: string;
  email: string;
  phoneNumber: string;
  image: IUploadedFile[];
}

export interface IUserRole {
  _id: string;
  title: string;
  description: string;
  pages: {
    pageId: string;
    read: boolean;
    write: boolean;
    delete: boolean;
    approve: boolean;
    myLocationData: boolean;
  }[];
}

export type GetUserData_Params = { authId: string };
export type GetUserData_Headers = { token: string };
export type GetUserData_Response = IResponse<Array<Omit<IUser, 'auth'> & { authId: string }> | null>;
export const GetUserData = async (params: GetUserData_Params, headers: GetUserData_Headers) => {
  const newApiPrefix = getApiPrefix();
  return axios.post(
    `${newApiPrefix}/dynamicmongodb/get`, 
    { 
      collection: handleGetCollection('user'), 
      filter: { auth: params.authId } 
    }, 
    { 
      headers: { 
        [REQUEST_HEADER_AUTH_KEY]: handleSetApiAuthorizationHeader(headers.token) 
      } 
    }
  );
};

export type GetAllUsersData_Response = IResponse<Array<Omit<IUser, 'auth'> & { authId: string }> | null>;
export const GetAllUsersData = async () => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<GetAllUsersData_Response>({ 
    url: `${newApiPrefix}/dynamicmongodb/get`, 
    method: 'post', 
    data: { 
      collection: handleGetCollection('user') 
    } 
  });
};

export type GetAllUserRoleTitles_Response = IResponse<Array<Pick<IUserRole, 'title'>> | null>;
export const GetAllUserRoleTitles = async () => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<GetAllUserRoleTitles_Response>({ 
    url: `${newApiPrefix}/dynamicmongodb/get`, 
    method: 'post', 
    data: { 
      collection: handleGetCollection('user-role'), 
      select: { title: 1 } 
    } 
  });
};

export type GetLoggedInUserRolePages_Params = { title: string };
export type GetLoggedInUserRolePages_Headers = { token: string };
export type GetLoggedInUserRolePages_Response = IResponse<Array<Pick<IUserRole, 'pages'>> | null>;
export const GetLoggedInUserRolePages = async (params: GetLoggedInUserRolePages_Params) => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<GetLoggedInUserRolePages_Response>({ 
    url: `${newApiPrefix}/dynamicmongodb/get`, 
    method: 'post', 
    data: { 
      collection: handleGetCollection('user-role'), 
      filter: { title: params.title }, 
      select: { pages: 1 } 
    } 
  });
};

export const GetLoggedInUserRolePagesWithCustomToken = async (params: GetLoggedInUserRolePages_Params, headers: GetLoggedInUserRolePages_Headers) => {
  const newApiPrefix = getApiPrefix();
  return axios.post(
    `${newApiPrefix}/dynamicmongodb/get`, 
    { 
      collection: handleGetCollection('user-role'), 
      filter: { title: params.title }, 
      select: { pages: 1 } 
    }, 
    { 
      headers: { 
        [REQUEST_HEADER_AUTH_KEY]: handleSetApiAuthorizationHeader(headers.token) 
      } 
    }
  );
};
